module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/65441e3956a47a9f5da9d8b4225b868e.png";